module.exports = __webpack_public_path__ + "img/owl_ad.bf9e95f9.svg";